<template>
  <div class="w-100 h-100 bg-gray100 d-flex align-items-center justify-content-center">
    <div class="mt-n5 w-25 bg-white rounded-lg p-5 shadow-custom">
      <h5 class="alert-heading">
        {{ $t('forgot.title') }}
      </h5>
      <div class="w-100 text-left">
        <b-form @submit="submit">
          <b-form-group>
            <!-- <h6 class="font-size-md">
              <span class="ml-n1 text-danger">*</span>email
            </h6> -->
            <b-form-input
              v-model="form.email.value"
              :placeholder="$t('forgot.form.email.placeholder')"
              size="sm"
              type="text"
              class="rounded-pill"
              :class="form.email.dirty && !form.email.valid ? 'is-invalid' : ''"
              autocomplete="off"
              max-length="50"
              required
              @blur="onEmailBlur"
              @input="onEmailInput"
            />
            <div class="invalid-feedback">
              {{ form.email.feedback }}
            </div>
          </b-form-group>
          <div class="mt-3 text-center">
            <button type="submit" :disabled="!form.valid" class="mx-1 btn btn-sm btn-primary rounded-pill">
              <span class="px-3">{{ $t('forgot.form.submit') }}</span>
            </button>
          </div>
        </b-form>
      </div>
    </div>
  </div>
</template>
<script>
import PermissionService from '@/services/PermissionService';

export default {
  data() {
    const vm = this;

    return {
      form: {
        validate() {
          this.email.dirty = true;
          this.email.validate();
        },
        get valid() {
          return this.email.valid;
        },
        email: {
          value: '',
          valid: false,
          dirty: false,
          validate() {
            this.valid = this.validation.required.validate(this.value) && this.validation.format.validate(this.value);
          },
          get feedback() {
            return this.validation.required.feedback || this.validation.format.feedback;
          },
          validation: {
            required: {
              validate(value) {
                this.valid = value.length > 0;
                return this.valid;
              },
              get feedback() {
                return this.valid ? '' : vm.$t('forgot.form.email.feedback.required');
              },
              valid: true
            },
            format: {
              validate(value) {
                const reg = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;
                this.valid = reg.test(value);
                return this.valid;
              },
              get feedback() {
                return this.valid ? '' : vm.$t('forgot.form.email.feedback.format');
              },
              valid: true
            }
          }
        }
      }
    };
  },
  methods: {
    onEmailBlur() {
      this.form.email.dirty = true;
      this.form.email.validate();
    },
    onEmailInput() {
      this.form.email.validate();
    },
    // 寄出
    submit(event) {
      event.preventDefault();
      const vm = this;

      vm.form.validate();

      if (vm.form.valid) {
        vm.$loading(async () => {
          try {
            await PermissionService.SendForgotMailAsync(vm.form.email.value);
            vm.$popup.alert(vm.$t('forgot.sent').replace('{email}', vm.form.email.value));
          } catch (err) {
            if (err.response.status === 404) {
              vm.$popup.alert(vm.$t('forgot.emailNotExists'));
            } else {
              vm.$popup.alert(vm.$t('forgot.sendFailed'));
            }
          }
        });
      }
    }
  }
};
</script>
